import { Component, OnInit, Input } from '@angular/core';
import {Status} from './status';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { headersToString } from 'selenium-webdriver/http';
import { tokenKey } from '@angular/core/src/view';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { StatusService } from './statusService';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.less']
})
export class StatusComponent implements OnInit {
  @Input() status: Status
  @Input() txt: String
  statuses: Status[]
  
  private location: Location
  
constructor(private http: HttpClient,  private route: ActivatedRoute,private statusservice: StatusService) { }

  ngOnInit() {
  }


  save(): void {
   
    this.statusservice.updateStatus(this.status)
      .subscribe();
  }
  
 getStatusById(id: number)
 {
  this.statusservice.getStatus(id).subscribe(status => this.status = status);
  
 }
  goBack(): void {
    this.location.reload;
  }
}
